// eslint-disable-next-line import/prefer-default-export
export const commonState = {
  rallyClose: null,
};

// 모바일, PC 구분
export function Mobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) return 'Mobile';
  return 'PC';
}
